import type React from 'react';

import * as styles from './styles';

import type { ChecklistVehicle } from '@cobliteam/api-lib';

import { CarsIcon, DescriptionListDefault, DescriptionListMedium, DriversCbIcon, PlaceholderText } from '@cobliteam/base-components';

export interface DrawerHeaderProps {
  vehicle?: ChecklistVehicle;
  createdBy?: string;
}

const getVehicleInfo = (vehicle: ChecklistVehicle) => {
  const { licensePlate = 'Placa não cadastrada', model = 'Modelo não cadastrado' } = vehicle;

  return <DescriptionListDefault>{`${licensePlate} - ${model}`}</DescriptionListDefault>;
};

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ vehicle, createdBy }) => (
  <div className={styles.drawerHeader}>
    <div className={styles.headerItem}>
      <div className={styles.textAndIcon}>
        <CarsIcon className={styles.icon} />
        <DescriptionListMedium>Veículo</DescriptionListMedium>
      </div>
      {(vehicle && getVehicleInfo(vehicle)) || <PlaceholderText>Sem associação</PlaceholderText>}
    </div>
    <div className={styles.headerItem}>
      <div className={styles.textAndIcon}>
        <DriversCbIcon className={styles.icon} />
        <DescriptionListMedium>Motorista</DescriptionListMedium>
      </div>
      <DescriptionListDefault>{createdBy}</DescriptionListDefault>
    </div>
  </div>
);

export default DrawerHeader;
